export const DEFAULT_VIEW_ID = 'default';
export const VIEWS_COLLECTION = 'views';
export const FS_ACTIVE_VIEW_PATH = 'activeView';
